import * as microsoftTeams from '@microsoft/teams-js';
import * as React from 'react';

/**
 * This component is loaded when the Azure implicit grant flow has completed.
 */
class ClosePopup extends React.Component {
  public componentDidMount() {
    microsoftTeams.initialize();

    // The Azure implicit grant flow injects the result into the window.location.hash object. Parse it to find the results.
    const hashParams = this.getHashParameters();
    if (hashParams['error']) {
      // Authentication/authorization failed
      microsoftTeams.authentication.notifyFailure(hashParams['error']);
    } else if (hashParams['code'] && hashParams['id_token']) {
      microsoftTeams.authentication.notifySuccess(hashParams['id_token']);
    } else {
      microsoftTeams.authentication.notifyFailure('UnexpectedFailure');
    }
  }

  // Helper function that converts window.location.hash into a dictionary
  public getHashParameters() {
    const hashParams = {};
    window.location.hash
      .substring(1)
      .split('&')
      .forEach(function (item) {
        const [key, value] = item.split('=');
        hashParams[key] = decodeURIComponent(value);
      });
    return hashParams;
  }

  public render() {
    return (
      <div>
        <h1>Consent flow complete.</h1>
      </div>
    );
  }
}

export default ClosePopup;
